import { BilableAmountType } from '@nx-ws/bhn-enums/bilable-amount-type.enum';
import { TierDto } from './tier.dto';

export class RateDto {
  id: string;
  sequence: number;
  name: string;
  payload: string;
  basisType = BilableAmountType.PRINCIPAL;
  basis: string;
  optimize: string;
  tiers: TierDto[] = [];
  transactionSpecId: string;

  constructor(d?: RateDto | null) {
    if (!d) {
      return;
    }
    this.id = d.id;
    this.sequence = d.sequence;
    this.name = d.name;
    this.payload = d.payload;
    this.basisType = d.basisType || BilableAmountType.PRINCIPAL;
    this.basis = d.basis;
    this.optimize = d.optimize;
    this.transactionSpecId = d.transactionSpecId;

    if (d.tiers) {
      this.tiers = d.tiers.map(i => new TierDto(i));
    }
  }
}
